import { useState, useEffect, useRef } from "react";
import ChartList from "./chartlist";
import PersonalChat from "./personalchart";
import api from "../../api/api";
import { Drawer, Skeleton } from "@mui/material";
import dayjs from "dayjs";
import NewsFeed from "./newsfeed";

const ChatWrapper = ({setChat,patientdata,flow,top=''}) => {
  const [togglescreen, setToggleScreen] = useState(true);
  const[patientid,setPatientId]=useState('')
 const [selectedDate, setSelectedDate] = useState(dayjs());
   const [isNewPatient,setIsNewPatient]=useState(false)
   const[otherViews,setOtherViews]=useState('')
  // Create a ref to track the chat wrapper container
  const chatWrapperRef = useRef(null);
  // Function to detect clicks outside the chat wrapper
  const handleClickOutside = (event) => {
    // If the click was outside the component
    if (chatWrapperRef.current && !chatWrapperRef.current.contains(event.target)) {
      setChat(false);  // Hide the chat wrapper
    }
  };

  // Add event listener when component is mounted and remove it on cleanup
  useEffect(() => {
    // Add click listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component is unmounted
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); 

useEffect(()=>{
if(flow==='comment'){

  setPatientId(patientdata)
  setToggleScreen(false)
}
},[flow])
  return (<>
    <Drawer
           anchor="right"
           open={true}
           onClose={() => setChat(false)}
           sx={{
             '& .MuiDrawer-paper': {
               top:top===''?'64px':'0px', // Header height
              width: flow === 'comment' ? '30%' : '60%',
              //  height: top===''?'calc(100% - 64px)':'100%',
               position: 'absolute',
               scrollbarWidth:'none'
             },
           }}
         >
          <div
      ref={chatWrapperRef}  // Attach the ref here to monitor clicks inside this div
      // className="fixed top-15 right-1 z-40 min-h-[43%] h-auto sm:h-[90%]  p-2 sm:w-[30%] md:w-[50%] lg:w-[30%]"
      // style={{
      //   background: "#FFF",
      //   boxShadow: "0px 4px 35px 0px rgba(0, 0, 0, 0.25)",
      //   borderRadius: "12px",
      //   display: "flex",
      //   flexDirection: "column",
      // }}
    >
      {true ? (
        <div className="w-full">
          <div className="w-full flex flex-row px-2">
            {flow==='chat'?<div className="w-[50%} min-w-[50%] max-w-[50%]">
            <ChartList 
            isNewPatient={isNewPatient}
            setIsNewPatient={setIsNewPatient}
        selectedDate={selectedDate}
        setOtherViews={setOtherViews}
         otherviews={otherViews}
        setSelectedDate={setSelectedDate}
            setPatientId={setPatientId}
                 patient={patientid}
            setToggleScreen={setToggleScreen} />  
            </div>:<></>}
<div className={flow === 'comment' ? 'w-full' : 'w-[50%] min-w-[50%] max-w-[50%]'}>
  {otherViews=='newsfeed'?<>
  <NewsFeed
    isNewPatient={isNewPatient}
        setchat={setChat}
        otherviews={otherViews}
             setOtherViews={setOtherViews}
          patient={patientid}
          setToggleScreen={setToggleScreen} />
  
  </>:<PersonalChat 
    isNewPatient={isNewPatient}
    top={top}
        setchat={setChat}
          patient={patientid}
          setToggleScreen={setToggleScreen} />}

</div>

          </div>
          
         </div>
      ) : (
        // <div className="flex-1 overflow-hidden">
            <div className="w-full">
          <PersonalChat 
            isNewPatient={isNewPatient}
        setchat={setChat}
        top={top}
          patient={patientid}
          setToggleScreen={setToggleScreen} />
          </div>
      )}
    </div>
   
     </Drawer>
  
  
  </>
    // <div
    //   ref={chatWrapperRef}  // Attach the ref here to monitor clicks inside this div
    //   className="fixed top-15 right-1 z-40 min-h-[43%] h-auto sm:h-[90%]  p-2 sm:w-[30%] md:w-[50%] lg:w-[30%]"
    //   style={{
    //     background: "#FFF",
    //     boxShadow: "0px 4px 35px 0px rgba(0, 0, 0, 0.25)",
    //     borderRadius: "12px",
    //     display: "flex",
    //     flexDirection: "column",
    //   }}
    // >
    //   { togglescreen ? (
    //     <div className="w-full">
    //       <ChartList 
    //         setPatientId={setPatientId}
    //         setToggleScreen={setToggleScreen} />
    //     </div>
    //   ) : (
    //     <div className="flex-1 overflow-hidden">
    //       <PersonalChat 
    //       patient={patientid}
    //       setToggleScreen={setToggleScreen} />
    //     </div>
    //   )}
    // </div>
  );
};

export default ChatWrapper;
